import { DrawerModal } from '@fagmobler/ui';
import { ServerProduct } from '@/lib/janitsjar/Product';

type MoreInfoProps = {
  product: ServerProduct;
  openedModal: string | null;
  closeModal: () => void;
};

export const MoreInfoModalKey = 'more_info';

export default function MoreInfo({
  product,
  openedModal,
  closeModal,
}: MoreInfoProps) {
  if (!product.texts) return null;

  const hasFacts = !!product.texts?.details || !!product.texts?.keyproperties;

  return (
    <DrawerModal
      isOpen={openedModal === MoreInfoModalKey}
      onClose={closeModal}
      title="Les mer"
    >
      <div className="p-4 md:p-6 flex flex-col gap-2 items-start">
        <h1 className="hd-base">{product.posterName}</h1>
        {product.texts?.longdescription?.trim() && (
          <p className="body-sm text-neutral-70">
            {product.texts.longdescription}
          </p>
        )}

        {hasFacts && <h2 className="hd-base mt-4">Fakta</h2>}
        {product.texts?.details?.trim() && (
          <p
            className="body-sm text-neutral-70"
            dangerouslySetInnerHTML={{ __html: product.texts.details }}
          />
        )}
        {product.texts?.keyproperties?.trim() && (
          <p
            className="body-sm text-neutral-70"
            dangerouslySetInnerHTML={{ __html: product.texts.keyproperties }}
          />
        )}
      </div>
    </DrawerModal>
  );
}
